import React from 'react'

export const MoonPayLogo = (props: React.HTMLAttributes<SVGElement>) => {
  return (
    <svg
      width="160"
      height="160"
      viewBox="0 0 160 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="160" height="160" rx="32" fill="#7715F5" />
      <path
        d="M114.802 60.8685C117.821 60.8685 120.772 59.9734 123.281 58.2964C125.791 56.6195 127.747 54.236 128.902 51.4471C130.058 48.6583 130.36 45.5897 129.771 42.6292C129.182 39.6687 127.729 36.9493 125.594 34.8149C123.46 32.6804 120.74 31.2268 117.78 30.6379C114.819 30.0491 111.751 30.3514 108.962 31.5065C106.173 32.6617 103.789 34.6177 102.113 37.1276C100.436 39.6373 99.5405 42.5881 99.5405 45.6067C99.5403 47.6108 99.9351 49.5956 100.702 51.4473C101.469 53.2991 102.593 54.9816 104.01 56.3986C105.427 57.8159 107.11 58.9401 108.962 59.707C110.813 60.4739 112.798 60.8687 114.802 60.8685ZM68.0055 129.604C60.6479 129.604 53.4555 127.423 47.3378 123.335C41.2201 119.247 36.4519 113.437 33.6362 106.64C30.8206 99.8421 30.0839 92.362 31.5194 85.1457C32.9548 77.9295 36.4977 71.301 41.7004 66.0983C46.9031 60.8957 53.5317 57.3527 60.748 55.9172C67.9643 54.4818 75.4441 55.2185 82.2416 58.0342C89.0393 60.85 94.8493 65.6182 98.937 71.7357C103.025 77.8534 105.206 85.0459 105.206 92.4034C105.207 97.2889 104.244 102.126 102.375 106.64C100.506 111.153 97.7652 115.254 94.3108 118.709C90.8563 122.163 86.7553 124.903 82.2418 126.773C77.7284 128.642 72.8908 129.604 68.0055 129.604Z"
        fill="white"
      />
    </svg>
  )
}

export default MoonPayLogo
